import { useEffect, useRef } from 'react';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { EditorCustomFormat } from '@dev/template-editor';
import { hasAccessLevel } from '@/services/Secuirty';
import { EditorType } from '@/services/dictionaries/EditorType';
import { useAiTextFormat } from '../customFormats/useAiTextFormat';

export const useCustomFormats = (editorType?: EditorType): EditorCustomFormat[] | null => {
    const ref = useRef<EditorCustomFormat[] | null>(null);
    const { getAiTextFormat } = useAiTextFormat(editorType);

    const getCustomFormatsArray = (): EditorCustomFormat[] | null => {
        if (!hasAccessLevel(AccessLevel.ViewAITools)) {
            return null;
        }
        return [getAiTextFormat()];
    };

    useEffect(() => {
        ref.current = getCustomFormatsArray();
    }, []);
    return ref.current;
};
